import { IconBaseProps } from 'react-icons';
import { AnimalSpecies, HerdType } from 'app/agriculture/models/entities/herd/HerdAnimals';
import {
    CowIcon,
    DeerIcon,
    PigIcon,
    SheepIcon,
    HorseIcon,
    GoatIcon,
    AlpacaIcon,
    CalfIcon,
    BullIcon,
} from 'app/agriculture/icons';
import { Herd } from 'app/agriculture/queries/herds/types/Herd';

const herdTypeIconLookup: Partial<Record<HerdType, React.FunctionComponent<IconBaseProps>>> = {
    Cattle: CowIcon,
    Calf: CalfIcon,
    Bull: BullIcon,
};

const animalIconLookup: Record<AnimalSpecies, React.FunctionComponent<IconBaseProps>> = {
    Cow: CowIcon,
    Deer: DeerIcon,
    Pig: PigIcon,
    Horse: HorseIcon,
    Alpaca: AlpacaIcon,
    Goat: GoatIcon,
    Sheep: SheepIcon,
};

export function AnimalIcon({
    animalSpecies,
    herdType = null,
    ...iconBaseProps
}: {
    animalSpecies: Herd['animalSpecies'];
    herdType: Herd['herdType'];
} & IconBaseProps) {
    if (!herdType) {
        const Icon = animalIconLookup[animalSpecies];
        return <Icon {...iconBaseProps} />;
    }

    const Icon = herdTypeIconLookup[herdType] || animalIconLookup[animalSpecies];
    return <Icon {...iconBaseProps} />;
}
